<div class="flex-column gap-32">

    @if (isInitializing) {
        <app-card preCardTitle="Cartegraph management">
            <div *appCardContent class="settings-header-container">
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            </div>
        </app-card>
    } @else {
        <app-manage-cartegraph-header page="SUBMISSIONS"></app-manage-cartegraph-header>
        <app-card preCardTitle="Submissions to Cartegraph">
            <div *appCardContent>
                <ng-container *ngTemplateOutlet="searchForm"></ng-container>
                @if (!isLoading && (!tasks || tasks.data?.length <= 0)) {
                    <div>There are no data available with selected criteria.</div>
                }
                <ng-container *ngTemplateOutlet="table"></ng-container>
                <ng-container *ngTemplateOutlet="paginator"></ng-container>
            </div>
        </app-card>
    }
</div>

<ng-template #searchForm>
    <form [formGroup]="form">
        <div class="mt-8 mb-8 filter">
            <mat-form-field class="w-50" appearance="outline" color="accent" subscriptSizing="dynamic">
                <mat-label>Status</mat-label>
                <mat-select multiple="true" formControlName="processingStatus">
                    @for (status of processingStatuses; track status.id) {
                        <mat-option [value]="status">{{ status.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-50 ml-10" appearance="outline" color="accent" subscriptSizing="dynamic">
                <mat-label>Search</mat-label>
                <input matInput
                       autocomplete="new-text"
                       type="text"
                       formControlName="searchText">
            </mat-form-field>
            <div>
                <button mat-button color="accent" (click)="doSearch()">
                    Filter
                </button>
                <button mat-button color="accent" (click)="clearFilters()">
                    Clear Filters
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #paginator>
    <!-- ?? note: cannot be in the ngIf statement! -->
    <mat-paginator showFirstLastButtons
                   (page)="onPage($event)"
                   [pageSize]="pageSize"
                   [pageIndex]="pageIndex"
                   [length]="itemCount"
                   aria-label="Select page">
    </mat-paginator>

</ng-template>

<ng-template #table>
    @if (!isLoading && tasks && tasks.data?.length > 0) {

        <table mat-table
               class="tasks-table"
               matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection"
               [dataSource]="tasks.data"
               (matSortChange)="sortChange($event)">
            <ng-container matColumnDef="id">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> ...</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngTemplateOutlet="status;context:{element:element}"></ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="taskType">
                <th mat-header-cell *matHeaderCellDef> Type</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngTemplateOutlet="taskType;context:{element:element}"></ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="created">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Created</th>
                <td mat-cell *matCellDef="let element"> {{ element.created | date:'short' }}</td>
            </ng-container>

            <ng-container matColumnDef="shift">
                <th mat-header-cell *matHeaderCellDef> Shift</th>
                <td mat-cell *matCellDef="let element">
                    @if (!!element.shiftId) {
                        <a target="_blank" [routerLink]="shiftLink(element.shiftId)"
                           aria-label="Open shift detail">{{ element.shiftId }}</a>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="cgIdField">
                <th mat-header-cell *matHeaderCellDef> Cartegraph</th>
                <td mat-cell *matCellDef="let element" class="cgfields">
                    @for (task of element.cgResult?.tasks; track task.id) {
                        <a target="_blank" [href]="cgDetailLink(task.cgOid)" aria-label="Open Cartegraph detail">
                            {{ task.cgId }}
                            @if (task.type === 'CDOT') {
                                <sup>*</sup>,
                            }
                        </a>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>...</th>
                <td mat-cell *matCellDef="let element">
                    @if (element.processStatus === 'FAIL' && (element.cgResult?.tasks?.length === null || element.cgResult?.tasks?.length === undefined)) {
                        <button mat-stroked-button
                                color="accent"
                                style="width:100% !important;"
                                (click)="reprocessSyncTask(element)">
                            re-process
                        </button>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    }
</ng-template>

<ng-template #status datatype="CartegraphSyncTask" let-element="element">
    <button mat-icon-button
            color="accent"
            class="mt-8"
            (click)="messageDetail(element)">
        @switch (element.processStatus) {
            @case ('WAITING') {
                <mat-icon class="waiting" [title]="element.processStatus" aria-hidden="false"
                          [matBadge]="element.retryCount">hourglass_bottom
                </mat-icon>
            }
            @case ('FAIL') {
                <mat-icon class="fail" [title]="element.processStatus" aria-hidden="false"
                          [matBadge]="element.retryCount">error
                </mat-icon>
            }
            @case ('SUCCESS') {
                <mat-icon class="success" [title]="element.processStatus">check_circle</mat-icon>
            }
            @case ('NONE') {
                <mat-icon class="none" [title]="element.processStatus">block</mat-icon>
            }
        }
    </button>
</ng-template>

<ng-template #taskType let-task="element">
    <span (dblclick)="updateStatus(task)">
        @switch (task.taskType) {
            @case ('SHIFT_END_POSTPROCESS') {
                Shift
            }
            @case ('DVIR_PRE_INSPECTION') {
                Pre
            }
            @case ('DVIR_POST_INSPECTION') {
                Post
            }
            @case ('OBSERVATION') {
                Obs
            }
        }
    </span>
</ng-template>

